import { axios } from '@Root/API'

export const edit = (courseSessionId, data) => {
	return axios.post(`hesa-detail/course-session/${courseSessionId}/module-instance`, data)
}
